import React from "react";
import {
    Text, View, Image
} from "react-native";

import { ZeroScreenData } from "../../utils/constants/ZeroScreenConstants";

import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";

import * as CommonUtils from '../../utils/services/CommonUtils';

export const CommonZeroScreen = (props) => {
    const zeroScreenData = ZeroScreenData[props?.screenName ?? 'emptyCart']
    const viewStyle = props?.viewStyle ?? null
    const imageHeight = zeroScreenData?.height ?? 220
    const imageWidth = zeroScreenData?.width ?? 220
    return <View style={[AppStyles.alignCenter, viewStyle]}>
        <Image style={{ height: imageHeight, width: imageWidth }}
            source={{ uri: CommonUtils.getImagePath(zeroScreenData.image) }} />
        <Text style={[TextStyle.text18xb, TextStyle.alignCenter, AppStyles.mt24,
        { width: AppTheme.appWidth - 96 }]}>
            {zeroScreenData.title}</Text>
        <Text style={[TextStyle.text16, TextStyle.alignCenter, AppStyles.mt8,
        { width: AppTheme.appWidth - 96 }]}>
            {zeroScreenData.subTitle}</Text>
    </View>
}